/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Absences_StartInputs */

const en_tables_absences_start = /** @type {(inputs: Tables_Absences_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

const de_tables_absences_start = /** @type {(inputs: Tables_Absences_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

/**
* | output |
* | --- |
* | "Start" |
*
* @param {Tables_Absences_StartInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_absences_start = /** @type {((inputs?: Tables_Absences_StartInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Absences_StartInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_absences_start(inputs)
	return de_tables_absences_start(inputs)
});